// Bootstrap for Sylvie theme web components.
// Individual components are loaded as needed by the templates that use them.
// This file exists so layout/theme.liquid has a stable entry point.
window.Sylvie = window.Sylvie || {};

customElements.define('product-info', class extends HTMLElement {});
